import * as React from "react";
import type { SVGProps } from "react";
const SvgMaximize2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 2a1 1 0 1 0 0 2zm6 1h1a1 1 0 0 0-1-1zm-1 6a1 1 0 1 0 2 0zM9 22a1 1 0 1 0 0-2zm-6-1H2a1 1 0 0 0 1 1zm1-6a1 1 0 1 0-2 0zm9.293-5.707a1 1 0 0 0 1.414 1.414zm-2.586 5.414a1 1 0 0 0-1.414-1.414zM15 4h6V2h-6zm5-1v6h2V3zM9 20H3v2h6zm-5 1v-6H2v6zM20.293 2.293l-7 7 1.414 1.414 7-7zM3.707 21.707l7-7-1.414-1.414-7 7z"
    />
  </svg>
);
export default SvgMaximize2;
